<template>
  <div class="launcher-container" :class="{ 'launcher-right': position === 'right', 'launcher-left': position === 'left' }">
    <div class="message-info message-info-right" @click.prevent="open" v-if="isOpen === false && position === 'right' && animateMessageInfo" v-html="chatbotChamada" :style="{backgroundColor: chatbotColors.launcher.bg, borderBottomColor: chatbotColors.launcher.bg}"></div>

    <div v-if="showLauncher" class="sc-launcher" :class="{opened: isOpen}" @click.prevent="isOpen ? close() : open()" :style="{backgroundColor: isOpen ? chatbotColors.launcher.bg : 'transparent'}">
      <img v-show="isOpen && chatbotImageLauncherIsReady" class="sc-closed-icon" :src="iconClose"  alt="" />
      <div v-show="isOpen === false && animatePulse" class="sc-open-icon-pulse animate-bounce-in" :style="{ backgroundColor: chatbotColors.launcher.bg }"></div>
      <img v-show="isOpen === false" class="sc-open-icon" :src="chatbotImageLauncher" @load="chatbotImageLauncherLoaded" :class="{ 'animate-bounce-in': chatbotImageLauncherIsReady }" alt="" />
      <div v-show="isOpen === false && animateOnlineIndicator" class="online-indicator animate-bounce-in"></div>
      <div v-if="newMessagesCount > 0 && !isOpen && animateNewMessagesCount" class="sc-new-messsages-count animate-bounce-in">
        {{newMessagesCount}}
      </div>
    </div>

    <div class="message-info message-info-left" @click.prevent="open" v-if="isOpen === false && position === 'left' && animateMessageInfo" v-html="chatbotChamada" :style="{backgroundColor: chatbotColors.launcher.bg, borderBottomColor: chatbotColors.launcher.bg}"></div>

    <ChatWindow
      :showLauncher="showLauncher"
      :showCloseButton="showCloseButton"
      :messageList="messageList"
      :onUserInputSubmit="onMessageWasSent"
      :chatbotName="chatbotName"
      :chatbotImage="chatbotImage"
      :isOpen="isOpen"
      :onFullScreen="onFullScreen"
      :onClose="close"
      :showEmoji="showEmoji"
      :showFile="showFile"
      :showTypingIndicator="showTypingIndicator"
      :chatbotImageFooter="chatbotImageFooter"
      :chatbotColors="chatbotColors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :messageStyling="messageStyling"
      :position="position"
      @scrollToTop="$emit('scrollToTop')"
      @onType="$emit('onType')" />
  </div>
</template>
<script>
import ChatWindow from './ChatWindow.vue'
import CloseIcon from './assets/close-icon.png'

export default {
  components: {
    ChatWindow
  },
  props: {
    showEmoji: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    onFullScreen: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    showLauncher: {
      type: Boolean,
      default: true
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    chatbotName: {
      type: String,
      default: () => ''
    },
    chatbotImage: {
      type: String,
      default: () => ''
    },
    chatbotImageLauncher: {
      type: String,
      default: () => ''
    },
    chatbotImageFooter: {
      type: String
    },
    chatbotChamada: {
      type: String,
      default: () => null
    },
    position: {
      type: String,
      required: true
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: () => []
    },
    newMessagesCount: {
      type: Number,
      default: () => 0
    },
    showTypingIndicator: {
      type: String,
      default: () => ''
    },
    chatbotColors: {
      type: Object,
      required: false,
      validator: c =>
        'header' in c
        && 'bg' in c.header
        && 'text' in c.header
        && 'launcher' in c
        && 'bg' in c.launcher
        && 'messageList' in c
        && 'bg' in c.messageList
        && 'sentMessage' in c
        && 'bg' in c.sentMessage
        && 'text' in c.sentMessage
        && 'receivedMessage' in c
        && 'bg' in c.receivedMessage
        && 'text' in c.receivedMessage
        && 'userInput' in c
        && 'bg' in c.userInput
        && 'text' in c.userInput,
      default: function () {
        return {
          header: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          launcher: {
            bg: '#4e8cff'
          },
          messageList: {
            bg: '#ffffff'
          },
          sentMessage: {
            bg: '#4e8cff',
            text: '#ffffff'
          },
          receivedMessage: {
            bg: '#f4f7f9',
            text: '#ffffff'
          },
          userInput: {
            bg: '#f4f7f9',
            text: '#565867'
          }
        }
      }
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: () => false
    },
    messageStyling: {
      type: Boolean,
      default: () => false
    },
  },
  data () {
    return {
      iconClose: CloseIcon,
      chatbotImageLauncherIsReady: false,
      animateNewMessagesCount: false,
      animateOnlineIndicator: false,
      animatePulse: false,
      animateMessageInfo: false,
    }
  },
  methods: {
    chatbotImageLauncherLoaded () {
      this.chatbotImageLauncherIsReady = true;

      setTimeout(() => {
        this.animateNewMessagesCount = true;
      }, 600);

      setTimeout(() => {
        this.animateOnlineIndicator = true;
      }, 800);

      setTimeout(() => {
        this.animatePulse = true;
        this.animateMessageInfo = true;
      }, 1200);
    }
  }
}
</script>

<style scoped>
.launcher-container {
  position: fixed;
  bottom: 15px;
  display: flex;
  align-items: center;
}
.launcher-container.launcher-left {
  left: 20px;
}
.launcher-container.launcher-right {
  right: 20px;
}
.message-info {
  position: relative;
  padding: 10px;
  color: white;
  border-radius: 10px;
  /* position: fixed; */
  /* bottom: 34px; */
  font-size: 14px;
  box-shadow: 0 6px 13px 0 rgba(0,0,0,.23);
  cursor: pointer;
  animation: balloon-in 0.7s ease-in-out forwards;
}

@keyframes balloon-in {
  0% {
    transform: rotate(-90deg) scale(0);
  }
  50% {
    transform: rotate(10deg) scale(1.1);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

.message-info.message-info-right {
  margin-right: 15px;
  transform-origin: 100% 50%;
  /* right: 100px; */
}
.message-info.message-info-left {
  margin-left: 15px;
  transform-origin: 0% 50%;
  /* left: 100px; */
}
.message-info:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border: .75rem solid transparent;
	border-top: none;
  border-bottom-color: inherit;
  top: 50%;
  margin-top: -6px;
}
.message-info.message-info-right:before {
  right: -13px;
  transform: rotate(90deg);
}
.message-info.message-info-left:before {
  left: -13px;
  transform: rotate(-90deg);
}

.sc-launcher {
  position: relative;
  width: 60px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  /* position: fixed; */
  /* right: 25px; */
  /* bottom: 25px; */
  border-radius: 50%;
  box-shadow: none;
  transition: box-shadow 0.2s ease-in-out;
  cursor: pointer;
}

.sc-launcher:before {
  content: '';
  position: relative;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  transition: box-shadow 0.2s ease-in-out;
}

.sc-launcher .sc-open-icon,
.sc-launcher .sc-closed-icon,
.sc-launcher .sc-open-icon-pulse {
  position: absolute;
  top: 0;
  left: 0;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  /* position: fixed; */
  /* right: 25px; */
  /* bottom: 25px; */
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
}

.sc-launcher .sc-closed-icon {
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
  width: 60px;
  height: 60px;
}

/* Animação pulsante */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  80% {
    transform: scale(1.6);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.sc-launcher .sc-open-icon-pulse {
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
  animation: pulse 2s infinite;
}

.sc-launcher .sc-open-icon {
  box-sizing: border-box;
  opacity: 1;
}

.sc-launcher.opened .sc-open-icon {
  transform: rotate(-90deg);
  opacity: 1;
}

.sc-launcher.opened .sc-closed-icon {
  transform: rotate(-90deg);
  opacity: 1;
}

.sc-launcher.opened:before {
  box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
}

.sc-launcher:hover {
  box-shadow: 0 6px 13px 0 rgba(0,0,0,.23);
}

.online-indicator {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 100%;
  background-color: green;
  bottom: 1px;
  right: 1px;
  border: 2px solid white;
}

.sc-new-messsages-count {
  position: absolute;
  top: -3px;
  left: 41px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
	width: 22px;
  height: 22px;
  background: #ff4646;
  color: white;
  text-align: center;
  margin: auto;
  font-size: 12px;
  font-weight: 500;
}

.animate-bounce-in {
  animation: bounce-in 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  70% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
